// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
let QuestionEditor
export default QuestionEditor = (function () {
  QuestionEditor = class QuestionEditor extends (
    require("lib/static-shim").default(
      require("lib/uniform/views/form").default
    )
  ) {
    constructor(...args) {
      super(...args)
      this.onModelSave = this.onModelSave.bind(this)
    }

    static initClass() {
      this.prototype.className = "pw-uniform"

      this.prototype.events = {
        "click a.cancel": "cancel",
        "click .save-question": "saveQuestion",
        "click a.add-description": "addDescription"
      }
    }

    initialize() {
      // make sure events are inherited...
      this.events = _.extend({}, QuestionEditor.prototype.events, this.events)
      this.delegateEvents()
      if (this.model) {
        return this.model.snapshot()
      }
    }

    addDescription() {
      this.$(".add-description").hide()
      return this.$(".add-description-container").show()
    }

    onModelSave(resp) {
      return this.trigger("state-change", "view")
    }

    cancel() {
      this.model.rollback()
      return this.trigger(
        "state-change",
        (this.model.isNew() && "new") || "view"
      )
    }
  }
  QuestionEditor.initClass()
  return QuestionEditor
})()
